<template>
  <div class="rebateDisCode">
    <div class="titleBox">
      <span class="title">{{ $t("Fm2shortlinkbate.Fm2ShortLink") }}</span>
      <span class="content">{{ $t("Fm2shortlinkbate.LinkisaFast") }}</span>
    </div>

    <div class="newInfoBox">
      <el-steps :active="3" align-center>
        <el-step>
          <div slot="description" class="titOne">
            {{ $t("Fm2shortlinkbate.CreatetoShorten") }}<br />{{
              $t("Fm2shortlinkbate.CreatetoShorten2")
            }}
          </div>
        </el-step>
        <el-step>
          <div slot="description" class="titThree">
            {{ $t("Fm2shortlinkbate.clickyourlin") }}<br />{{
              $t("Fm2shortlinkbate.clickyourlin2")
            }}
          </div>
        </el-step>
        <el-step>
          <div slot="description" class="titOne">
            {{ $t("Fm2shortlinkbate.Earnmore") }}<br />{{
              $t("Fm2shortlinkbate.Earnmore2")
            }}
          </div>
        </el-step>
      </el-steps>
    </div>
    <div class="pub-tit0" style="margin-top: 40px;font-size: 18px;">
      {{ $t("Fm2shortlinkbate.Fm2Earnings") }}
    </div>
    <div class="newInfoBox2">
      <div class="Multiplemodels">
        {{ $t("Fm2shortlinkbate.Multiplemodels") }}
      </div>
      <!-- <div class="Direct">
        1、{{ $t("Fm2shortlinkbate.Directjump1")
        }}<span>{{ $t("Fm2shortlinkbate.Directjump2") }}</span
        >{{$i18n.locale == 'en'?'￥':''}}{{$store.state.userInfo?.short_url_price[0]}}{{ $t("Fm2shortlinkbate.Directjump3")
        }}<span>{{ $t("Fm2shortlinkbate.Directjump4") }}</span>
      </div> -->
      <!-- <div class="Direct">
        1、{{ $t("Fm2shortlinkbate.Loginjump1")
        }}<span>{{ $t("Fm2shortlinkbate.Loginjump2") }}</span
        >{{$i18n.locale == 'en'?'￥':''}}{{$store.state.userInfo?.short_url_price[0]}}{{ $t("Fm2shortlinkbate.Loginjump3")
        }}<span>{{ $t("Fm2shortlinkbate.Loginjump4") }}</span>
      </div> -->
      <div class="Direct">
        1、{{ $t("Fm2shortlinkbate.Miniadjump1")
        }}<span>{{ $t("Fm2shortlinkbate.Miniadjump2") }}</span
        >{{$i18n.locale == 'en'?'￥':''}}{{$store.state.userInfo?.short_url_price[1]}}{{ $t("Fm2shortlinkbate.Miniadjump3")
        }}<span>{{ $t("Fm2shortlinkbate.Miniadjump4") }}</span>
      </div>
      <!-- <div class="Direct">
        3、{{ $t("Fm2shortlinkbate.Feemooadjump1")
        }}<span>{{ $t("Fm2shortlinkbate.Feemooadjump2") }}</span
        >{{$i18n.locale == 'en'?'￥':''}}{{$store.state.userInfo?.short_url_price[2]}}{{ $t("Fm2shortlinkbate.Feemooadjump3")
        }}<span>{{ $t("Fm2shortlinkbate.Feemooadjump4") }}</span>
      </div> -->
      <div class="Direct">
        2、{{ $t("Fm2shortlinkbate.Extrareferralbonus1")
        }}<span>{{ $t("Fm2shortlinkbate.Extrareferralbonus2") }}</span
        ><span
          @click="$router.push('/referralProgram')"
          style="color: #7e72f6; cursor: pointer"
          >{{ $t("Fm2shortlinkbate.Extrareferralbonus3") }}</span
        >
      </div>
    </div>
    <div class="pub-tit0 awrtet" style="margin-top: 40px;font-size: 18px;">
      <div>
        {{ $t("Fm2shortlinkbate.DataOverview")
        }}<span class="DataOverview2"
          >（{{ $t("Fm2shortlinkbate.DataOverview2") }}）</span
        >
      </div>
      <div class="minxi" @click="ViewDetailsFn">
        {{ $t("Fm2shortlinkbate.ViewDetails")
        }}<svg-btn
          icon-class="icon-right-black"
          style="width: 12px; height: 12px; color: #8a8b92"
        />
      </div>
    </div>

    <div class="rewardBox">
      <div class="reward">
        <span class="topFont">{{ $t("Fm2shortlinkbate.YesterdayViews") }}</span>
        <div class="buttomBox">
          <span class="leftFont">{{ Overview?.view_volume || 0 }}</span>
          <span class="rightFont">{{ $t("exPand.ci") }}</span>
        </div>
      </div>
      <div class="reward marLeft">
        <div class="twoTitle">
          <span class="topFont">{{
            $t("Fm2shortlinkbate.YesterdayRedirects")
          }}</span>
          <el-tooltip
            popper-class="markReferral"
            effect="dark"
            placement="bottom"
          >
            <div slot="content">
              <div>{{ $t("Fm2shortlinkbate.Yesterday") }}</div>
            </div>
            <img
              class="markImg"
              :src="$utils.getPng('referral-three')"
              alt=""
            />
          </el-tooltip>
        </div>
        <div class="buttomBox">
          <span class="leftFont">{{ Overview?.jump_volume || 0 }}</span>
          <span class="rightFont">{{ $t("exPand.ci") }}</span>
        </div>
      </div>
      <div class="reward marLeft">
        <div class="twoTitle">
          <span class="topFont">{{
            $t("Fm2shortlinkbate.YesterdayEarnings")
          }}</span>
        </div>
        <div class="buttomBox">
          <span class="leftFont">{{ Overview?.income_volume || 0 }}</span>
          <span class="rightFont">{{ $t("exPand.money") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDataOverview } from "@/utils/apiList/shortlink";
export default {
  data() {
    return {
      Overview: {}
    };
  },
  created() {
    this.getDataOverviewFn();
  },
  methods: {
    getDataOverviewFn(){
      getDataOverview()
        .then((res) => {
          if (res.status == 1) {
            this.Overview = res.data;
          }
        })
        .catch((err) => {});

    },
    ViewDetailsFn() {
      this.$emit("ViewDetails");
    },
  },
};
</script>

<style lang="scss" scoped>
.awrtet {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .minxi {
    font-weight: 400;
    font-size: 12px;
    color: #8a8b92;
    line-height: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }
}
.rewardBox {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  white-space: nowrap;
  .reward {
    width: 298px;
    display: flex;
    flex-direction: column;
    padding: 24px;
    background: #f9f9f9;
    border-radius: 12px;
    .topFont {
      font-weight: 500;
      font-size: 14px;
      color: #2c2c2c;
      line-height: 22px;
    }
    .buttomBox {
      display: flex;
      align-items: flex-end;
      .leftFont {
        font-weight: 600;
        font-size: 32px;
        color: #2c2c2c;
        line-height: 40px;
        // width: 225px;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .rightFont {
        font-weight: 500;
        font-size: 16px;
        color: #2c2c2c;
        line-height: 24px;
        margin-bottom: 4px;
        margin-left: 4px;
      }
    }
    .buttomFont {
      font-weight: 400;
      font-size: 12px;
      color: #8a8b92;
      line-height: 20px;
      margin-top: 12px;
    }
    .markImg {
      width: 16px;
      height: 16px;
      object-fit: cover;
      margin-left: 4px;
      cursor: pointer;
    }
    .twoTitle {
      display: flex;
      align-items: center;
    }
  }
  .rewardThree {
    padding-bottom: 20px !important;
  }
  .marLeft {
    margin-left: 19px;
  }
}
.DataOverview2 {
  display: inline-block;
  font-weight: 400;
  font-size: 12px;
  color: #7e72f6;
  margin-left: 4px;
}
.newInfoBox2 {
  padding: 16px 20px;
  margin-top: 20px;
  background: #f9f9f9;
  border-radius: 12px;
  .Multiplemodels {
    font-weight: 500;
    font-size: 14px;
    color: #2c2c2c;
    line-height: 22px;
  }

  .Direct {
    font-weight: 400;
    font-size: 14px;
    color: #2c2c2c;
    line-height: 22px;
    margin-top: 8px;

    span {
      color: #8a8b92;
    }
  }
}
::v-deep .newInfoBox {
  padding: 32px 41px;
  margin-top: 32px;
  background: #f9f9f9;
  border-radius: 12px;
  .coTued {
    color: #7e72f6 !important;
  }
  .el-step__head.is-finish {
    color: #7e72f6;
    border-color: #7e72f6;
  }
  .el-step__description {
    margin-top: 9px;
    font-weight: 500;
    font-size: 13px;
    color: #2c2c2c;
    line-height: 18px;
    padding-left: 10%;
    padding-right: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
    .titOne {
      width: 150px;
    }
    .titTwo {
      width: 150px;
    }
    .titThree {
      width: 160px;
    }
  }
  .el-step__line {
    height: 1px;
    background-color: #7e72f6;
  }
  .el-step__icon {
    width: 20px;
    height: 20px;
    border: none;
    background: #7e72f6;
    .el-step__icon-inner {
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
      line-height: 17px;
    }
  }
}
.rebateDisCode {
  padding-bottom: 100px;

  .titleBox {
    display: flex;
    flex-direction: column;
    .title {
      font-weight: 600;
      font-size: 18px;
      color: #2c2c2c;
      line-height: 24px;
      margin-bottom: 4px;
    }
    .content {
      font-weight: 400;
      font-size: 12px;
      color: #8a8b92;
      line-height: 20px;
    }
  }
}
</style>
